module.exports = __webpack_public_path__ + "static/media/vip-pass.1d5fde24.png";